import { useEffect } from 'react';
import { subscribeConsentLevelChange } from '@stepstone/user-consent-events';
import { updateConsent } from '../core/consent/consentSlice.js';
import { useAppDispatch } from './redux/index.js';
export const useConsentLevelSubscriber = () => {
    const dispatch = useAppDispatch();
    useEffect(() => {
        const unsubscribe = subscribeConsentLevelChange((e) => {
            dispatch(updateConsent(e.detail.isFunctional));
        });
        return () => unsubscribe();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};
//# sourceMappingURL=useConsentLevelSubscriber.js.map